import {
  type StackProps
} from "@mui/material";
import {
  CategoriesStack,
  CategoryDot,
  CategoryText,
  CategoryWrapper
} from "./CardCategories.styles";

export function CardCategories({
  categories,
  isHome=false,
  ...props
} : StackProps & {
  categories : string[]
  isHome?: boolean
}) {
  return (
    <CategoriesStack
      $isHome={ isHome }
      direction="row"
      width="100%"
      flexWrap="wrap"
      { ...props }
    >
      { categories && categories?.map((category: string) => (
        <CategoryWrapper
          key={ `category--${category}` }
        >
          <CategoryDot />
          <CategoryText>
            { category }
          </CategoryText>
        </CategoryWrapper>
      )) }
    </CategoriesStack>
  );
}
